<app-announcement-bar></app-announcement-bar>
<app-navbar-user [active]="'dashboard'"></app-navbar-user>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<div class="container-fluid dashboard p-4 main-content">
  <div class="row">
    <div class="col-md-12 mb-4">
      <div class="d-md-flex align-items-center justify-content-between d-block">
        <div class="d-flex align-items-center">
          <h2 class="m-0 page-title"><i class="bx bx-library btn-icon"></i> My Library</h2>
          <div class="d-sm-block d-md-inline mt-1 mb-3 mt-md-0 mb-md-0">
            <a class="btn btn-sm btn-dark  ms-2" [routerLink]="['/redeem-code']">
              <i class="bx bx-plus-circle fs-xl"></i>
              Redeem Code
            </a>
          </div>
        </div>


        <!--div class="d-md-flex justify-content-end align-items-center d-block">

          <div class="me-2">
            <div class="row g-3 align-items-center">
              <div class="col-auto">
                <input type="text" class="form-control form-control-sm form-control-sm" placeholder="Search scenarios.."
                  [(ngModel)]="searchQuery" />
              </div>
            </div>
          </div>

          <div class="position-relative d-inline-flex me-2" dropdown placement="bottom right">
            <button id="button-status" dropdownToggle type="button" class="btn btn-darken btn-sm"
              aria-controls="dropdown-sorter">
              {{ viewStatus | titlecase }} <i class="bx bx-chevron-down"></i>
            </button>
            <ul id="dropdown-status" *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-sm"
              role="menu" aria-labelledby="button-sorter">
              <li>
                <h6 class="dropdown-header">Status</h6>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" (click)="viewStatus = 'active'">
                  <i class="bx bx-check" [ngClass]="{ invisible: viewStatus != 'active' }"></i>
                  Active</a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" (click)="viewStatus = 'archived'">
                  <i class="bx bx-check" [ngClass]="{ invisible: viewStatus != 'archived' }"></i>
                  Archived</a>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" (click)="viewStatus = 'legacy'">
                  <i class="bx bx-check" [ngClass]="{ invisible: viewStatus != 'legacy' }"></i>
                  Legacy</a>
              </li>
            </ul>
          </div>


          <div class="position-relative d-inline-flex me-2" dropdown placement="bottom right">
            <button id="button-sorter" dropdownToggle type="button" class="btn btn-darken btn-sm"
              aria-controls="dropdown-sorter">
              {{ sortTitles[sort] }} <i class="bx bx-chevron-down"></i>
            </button>
            <ul id="dropdown-sorter" *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-sm"
              role="menu" aria-labelledby="button-sorter">
              <li>
                <h6 class="dropdown-header">Sort by</h6>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" (click)="onSetSortOrder('title', 'asc')">
                  <i class="bx bx-check" [ngClass]="{ invisible: sort != 'title' }"></i>
                  Alphabetical</a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" (click)="onSetSortOrder('created', 'asc')">
                  <i class="bx bx-check" [ngClass]="{ invisible: sort != 'created' }"></i>
                  Date Created</a>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" (click)="onSetSortOrder('modified', 'asc')">
                  <i class="bx bx-check" [ngClass]="{ invisible: sort != 'modified' }"></i>
                  Last Updated</a>
              </li>
              <li class="divider"></li>
              <li>
                <h6 class="dropdown-header">Order</h6>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" (click)="onSetOrder('asc')">
                  <i class="bx bx-check" [ngClass]="{ invisible: order != 'asc' }"></i>
                  <ng-container *ngIf="sort != 'title'">Oldest First</ng-container>
                  <ng-container *ngIf="sort == 'title'">A-Z</ng-container>
                </a>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" (click)="onSetOrder('desc')">
                  <i class="bx bx-check" [ngClass]="{ invisible: order != 'desc' }"></i>
                  <ng-container *ngIf="sort != 'title'">Newest First</ng-container>
                  <ng-container *ngIf="sort == 'title'">Z-A</ng-container>
                </a>
              </li>
            </ul>
          </div>
          <button class="btn btn-darken btn-sm me-1" [ngClass]="{ active: viewMode == 'grid' }"
            (click)="viewMode = 'grid'">
            <i class="bx bx-grid-alt"></i>
          </button>
          <button class="btn btn-darken btn-sm" [ngClass]="{ active: viewMode == 'list' }" (click)="viewMode = 'list'">
            <i class="bx bx-list-ul"></i>
          </button>
        </div-->


      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="libraryItems && libraryItems.length>0">
        <ng-container *ngIf="viewStatus == 'active'">
          <ng-container>

            <!-- grid view-->
            <ng-container *ngIf="viewMode == 'grid'">
              <div class="scenarios-container">
                <ng-container *ngFor="
                    let libraryItem of libraryItems;
                    let index = index
                  ">
                  <div *ngIf="index < perPage * (showMore + 1)">
                    <div class="card bg-white border-0 shadow-sm"
                     
                      style="overflow: hidden; width: 100%;aspect-ratio: 16/9;justify-content: flex-end;" target="_blank">
                      <img
                        [src]="libraryItem.thumb ? environment.mediaUrl +  '/assets/thumbs/' + libraryItem.thumb : 'https://placehold.co/600x400'"
                        class="card-img-top" alt="..." style="z-index: 0;">

                      <div class="card-content-container card-img-top" style="position: absolute;background:none">

                        <div class="card-hover-content">

                          <div class="card-action-btns">
                            <div class="toolbar-dock">
                              <div class="toolbar-dock-group">
                                <a class="btn" tooltip="Play" [delay]="300" container="body"
                                  [routerLink]="['/loader', libraryItem.author_id + '-' + libraryItem.scenario_id+ '-' + libraryItem.published_hash]"target="_blank">
                                  <i class="bx bx-play"></i>
                                </a>

                                <a class="btn" tooltip="Results" [delay]="300" container="body"
                                  [routerLink]="['/results']" [queryParams]="{lid:libraryItem.library_item_id}">
                                  <i class="bx bxs-bar-chart-alt-2"></i>
                                </a>

                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="db-scenario-info">
                      <div class="d-flex justify-content-between align-items-center">
                        <h3>
                          <a>{{
                            libraryItem.scenario_title
                            }}</a>
                        </h3>

                      </div>
                      <h4 class="db-scenario-modified">
                        Added {{ libraryItem.created | timeago }}<span *ngIf="libraryItem.expires"> <span class="mx-1">|</span> Expires {{ libraryItem.expires | timeago }}</span>
                      </h4>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="mt-3 small text-center" *ngIf="getByStatus(scenarios, 1, searchQuery).length > 0">
                Showing
                <span *ngIf="
                    (showMore + 1) * perPage < getByStatus(scenarios, 1, searchQuery).length
                  ">{{ (showMore + 1) * perPage }}
                </span>
                <span *ngIf="
                    (showMore + 1) * perPage >= getByStatus(scenarios, 1, searchQuery).length
                  ">{{ getByStatus(scenarios, 1, searchQuery).length }}
                </span>

                of {{ getByStatus(scenarios, 1, searchQuery).length }}
                <div class="d-flex justify-content-center mt-2">
                  <button class="btn btn-darken btn-sm" *ngIf="
                      getByStatus(scenarios, 1, searchQuery).length >
                      (showMore + 1) * perPage
                    " (click)="showMore = showMore + 1">
                    Show More
                  </button>
                </div>
              </div>
            </ng-container>

            <!-- list view -->

            <ng-container *ngIf="viewMode == 'list'">
              <table class="table table-hover table-list-view">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Last Modified</th>
                    <th>Created</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let scenario of getByStatus(scenarios, 1, searchQuery)">
                    <td>{{ scenario.title }}</td>
                    <td>{{ scenario.modified | timeago }}</td>
                    <td>{{ scenario.created | timeago }}</td>
                    <td>
                      <div class="btn-group" dropdown [container]="'body'">
                        <span id="button-basic" dropdownToggle type="button" class="text-dark action-dots pointer"
                          aria-controls="dropdown-basic">
                          <i class="bx bx-dots-vertical"></i>
                        </span>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-end  dropdown-menu-sm"
                          role="menu" aria-labelledby="button-basic">
                          <li role="menuitem">
                            <a class="dropdown-item" (click)="onLoadScenario(scenario)">Edit</a>
                          </li>

                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

          </ng-container>
        </ng-container>

      </div>
      <div *ngIf="!libraryItems || libraryItems.length <1">
        <p class="mt-4">No scenarios found.</p>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>